import { COLUMN_DESCRIPTION, COLUMN_NAME } from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";

const MobileAccountColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "accName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Description",
        accessor: "description",
        isNumeric: false,
        id: 1,
        sortByName: "accountType.atDesc",
        sortDirection: "asc",
        active: true,
        translationKey: "description",
        columnId: COLUMN_DESCRIPTION,
    }
];

export default MobileAccountColumns;
